import React from 'react';
import { connect } from 'react-redux';
import { logOutApp, setToken, setUserCredentials } from '../Actions/LoginAction';
import { withRouter } from 'react-router-dom';
import '../Assets/css/logindoc.scss';

const MobileOnlyRestriction = (props) => {
    const { logOutApp, history, setToken, setUserCredentials } = props;

    const handleLogout = () => {
        logOutApp().then((logoutResponse) => {
            localStorage.setItem("selectedTabName", "");
            setToken("", "", "", "", [], []).then(() => {
                setUserCredentials({});
                setTimeout(() => {
                    window.location.href = window.location.origin + "/#/" + localStorage.getItem('i18nextLng') + "/login";
                }, 500);
            });
        }).catch(() => {
            localStorage.setItem("selectedTabName", "");
            setToken("", "", "", "", [], []).then(() => {
                setUserCredentials({});
                setTimeout(() => {
                    window.location.href = window.location.origin + "/#/" + localStorage.getItem('i18nextLng') + "/login";
                }, 500);
            });
        });
    };

    return (
        <div className="loginBackground">
            <div className="appContainerInner" style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className="login_box_inner">
                    <div className="logo-box-inner">
                        <div className="titleposition">
                            <img src={require('../../../Utility/Public/images/logo.png')} className="logoInner" />
                        </div>
                    </div>
                    <div className="mobile-only-restriction-content">
                        <div className="restriction-icon-wrapper">
                            <i className="fa fa-mobile restriction-icon" aria-hidden="true"></i>
                        </div>
                        <h3 className="restriction-title">Mobile App Only</h3>
                        <p className="restriction-message">
                            Your organisation configuration is set for mobile application use only. You cannot use this web version anymore.
                        </p>
                        <p className="restriction-contact">
                            Please contact your administrator for assistance.
                        </p>
                        <div className="loginFormInnerDiv logbtndiv">
                            <button
                                type="button"
                                className="login-btn"
                                onClick={handleLogout}
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
};

export default connect(mapStateToProps, { logOutApp, setToken, setUserCredentials })(withRouter(MobileOnlyRestriction));
